export default __webpack_public_path__ + "static/media/IMG_3076_3_11zon.95ebc564.jpg";